module.exports = "/_next/static/images/TSVL-20aa230cc442c9f4c6e2a5f0c298fb05.svg";